<template>
    <div class="row">
        <div class="col-xs-12 col-sm-8">
            <div class="vrm-economic-block--border vrm-economic-block__datepicker">
                <div class="row">
                    <div
                        class="hidden-xxs col-xs-2 text-center vrm-economic-block__datepicker--icon"
                    >
                        <span
                            class="sg-vrm-icon_004_clock-32px vrm-economic-block__icon--big"
                        ></span>
                    </div>
                    <div class="col-xxs-12 col-xs-10">
                        <div class="row">
                            <div class="col-sm-6 vrm-date-time-picker__dropdown__custom">
                                <div class="sg-textfield-label">
                                    {{
                                        $t('datepicker.from', {
                                            i18nFallback: 'From',
                                        })
                                    }}
                                </div>
                                <div class="vrm-date-time-picker__dropdown__custom__inputs">
                                    <input
                                        :id="isDynamicEssPicker ? 'dpMinDess' : 'dpMin'"
                                        class="picker__input picker__input--align_left vrm-date-time-picker__dropdown__custom-date"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div class="col-sm-6 vrm-date-time-picker__dropdown__custom">
                                <div class="sg-textfield-label">
                                    {{
                                        $t('datepicker.to', {
                                            i18nFallback: 'To',
                                        })
                                    }}
                                </div>
                                <div class="vrm-date-time-picker__dropdown__custom__inputs">
                                    <input
                                        :id="isDynamicEssPicker ? 'dpMaxDess' : 'dpMax'"
                                        class="picker__input picker__input--align_left vrm-date-time-picker__dropdown__custom-date"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import 'air-datepicker/air-datepicker.css';
import VrmIconButton from '../../molecules/VrmIconButton';
import VrmDropdownMenu from './VrmDropdownMenu';
import { toSiteTime, toRangeTimestamp } from './utils';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmTimeInput from '@/vue/components/shared/date-time-picker/VrmTimeInput.vue';
import VrmDateTimePicker from '@/vue/components/shared/date-time-picker/VrmDateTimePicker.vue';

@Component({
    components: { VrmTimeInput, VrmIconButton, VrmDropdownMenu },
})
@AngularLocaleBundle('datepicker')
@AngularDirective('vrm-date-picker')
export default class VrmDatePicker extends VrmDateTimePicker {
    getMaxDate() {
        return toSiteTime(new Date(), this.siteUTCOffset);
    }

    updateRangeProp() {
        this.range.startDate = toRangeTimestamp(
            this.startDate,
            this.siteUTCOffset,
            this.installation.timezone,
        );
        this.range.endDate =
            toRangeTimestamp(this.endDate, this.siteUTCOffset, this.installation.timezone) - 1;
    }
}
</script>
